import {
  Checkbox,
  NO_DATA_PLACEHOLDER,
  TableBody,
  TableCell,
  TableHead,
  TableHeaderBulkSelectCheckbox,
  TableRow,
} from '@occc-app/design-system';
import { useBulkSelect } from '@occc-app/hooks/useBulkSelect';
import { Cpg, SubmissionGroupLocationFragment } from '@occc/graphql';

import {
  CpgAccountDataCells,
  CpgAccountHeaderCells,
} from '../scan-data-submission-groups-create/components/submission-group-locations-table/cpg-account-cells';

type RemoveModeProps = ReturnType<typeof useBulkSelect> & {
  isRemoveMode: true;
};

export type ScanDataSubmissionGroupDetailsLocationsTableProps = (
  | { isRemoveMode: false }
  | RemoveModeProps
) & {
  cpg?: Cpg;
  data?: SubmissionGroupLocationFragment[];
};

export const ScanDataSubmissionGroupDetailsLocationsTable = (
  props: ScanDataSubmissionGroupDetailsLocationsTableProps,
) => {
  const currentPageLocationUuids = props.data?.map((item) => item.uuid) || [];

  return (
    <>
      <TableHead>
        <TableRow>
          {props.isRemoveMode && (
            <TableCell padding='checkbox'>
              <TableHeaderBulkSelectCheckbox
                bulkSelectedItems={props.bulkSelectedItems}
                handleBulkSelectMultiple={props.handleBulkSelectMultiple}
                currentPageItems={currentPageLocationUuids}
              />
            </TableCell>
          )}
          <TableCell>Site ID</TableCell>
          <TableCell>Site Name (DBA)</TableCell>
          {props.cpg && <CpgAccountHeaderCells cpg={props.cpg} />}
          <TableCell>Site Address</TableCell>
          <TableCell>Site Phone Number</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {props.data?.map((location) => {
          const address = location.address;
          const locationCity = address?.city || '';
          const locationState = address?.state || '';
          const locationStreet = address?.street1 || '';
          const locationZip = address?.zipCode || '';

          const siteId = location.siteSystemConfiguration?.[0]?.identifier || NO_DATA_PLACEHOLDER;

          const siteName =
            location.siteSystemConfiguration?.[0]?.details?.siteName ||
            location.address?.alias ||
            siteId;

          const sitePhoneNumber = location.phoneNumbers[0]?.phoneNumber || NO_DATA_PLACEHOLDER;

          return (
            <TableRow key={location.uuid}>
              {props.isRemoveMode && (
                <TableCell padding='checkbox'>
                  <Checkbox
                    checked={props.bulkSelectedItems.has(location.uuid)}
                    onClick={(event) => {
                      event.stopPropagation();
                      props.handleItemSelect(location.uuid);
                    }}
                  />
                </TableCell>
              )}
              <TableCell>{siteId}</TableCell>
              <TableCell>{siteName}</TableCell>
              {props.cpg && <CpgAccountDataCells cpg={props.cpg} location={location} />}
              <TableCell>{`${locationStreet} ${locationCity}, ${locationState} ${locationZip}`}</TableCell>
              <TableCell>{sitePhoneNumber}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </>
  );
};
